"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Subsection_1 = require("../../helpers/Subsection");

exports.AlternatingTextMediaLikeSubsectionRenderer = function (_a) {
  // console.log('- - AlternatingTextMediaLikeSubsectionRenderer');
  var data = _a.data,
      Component = _a.component,
      props = _a.props;
  var children = data.map(function (contentElements, index) {
    return react_1["default"].createElement(Subsection_1.Subsection, {
      key: "AlternatingTextMediaLikeSubsectionRenderer-" + index
    }, react_1["default"].createElement(Component, __assign({
      data: contentElements,
      reverseOrder: index % 2 === 0
    }, props)));
  });
  return react_1["default"].createElement(react_1["default"].Fragment, null, children);
};